import React from 'react';
import EllipsisIcon from "../icons/EllipsisIcon";

interface GeneratingStatusProps {
    text: string;
}

const GeneratingStatus: React.FC<GeneratingStatusProps> = ({ text }) => {
    return (
        <div className="flex h-9 p-3 px-1.5 justify-left items-center rounded-xl mb-5">
            <div className="flex w-5 px-0 justify-center items-center gap-1.5 mr-4">
                <EllipsisIcon />
            </div>


            <div className="font-manrope text-sm font-medium leading-[140%]  bg-linear-to-r from-hex-gray-900 via-hex-gray-400 to-hex-gray-600 bg-clip-text text-transparent animate-gradient-x">
                {text}
            </div>
        </div>
    );
};

export default GeneratingStatus;
